import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Corejava = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Why Core Java</h1>
          <p>Learn through our all-inclusive Corejava adn Advance Java course syllabus with adequate practical experiences to develop the easy to manage Applicaitons. Our trainers are skilled and have the industry experience to handle classes
            as per the student’s proficiency. We assist you for the assured placement after the successful course completion with valuable certification at Acrosys Technologies.</p>
          <p>
            <b>Session 1: Introduction to Java</b>
          </p><p>Introduction and environment setup</p>
          <b>Session 2: Class, Ojects and Datatypes</b>
          <p>Class , Object and features,</p>
          <b>Session 3: Fundamentals of Java</b>
          <p>Comments, Statements, Blocks, identifiers, Keywords ,Literals,Prmitive Datatype, Variables, Type Casting and Operators</p>
          <b>Session 4: Control Structures </b>
          <p>Types of Control , Decision Control, Repitition Control</p>
          <b>Session 5: Input Fundamentals and Data Types</b>
          <p> Java inputs, scanner, java array,</p>
          <b>Session 6:OOPS</b>
          <p> Procedural vs OOPS,OOPS Introduction, Abstraction, Encapsulation,Polymorphism, Inheritance, class and ojects, method and behaviour, contructor vs method, java access modifier </p><b> Session 7: Filters </b>
          <p>Built-In Filters, Using Angular JS Filters Creating Custom Filters</p>
          <b>Session 8: inner class</b>
          <p />
          <b> Session 9: interface </b>
          <p />
          <b> Session 10: Exception Handling</b>
          <p />
          <b> Session 11: Mutlithreading </b>
          <p />
          <b>Session 12: Garbage Collection</b>
          <p />
          <b>Session 13: Packages</b>
          <p />
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}

        {/* Comment List End */}
        {/* Comment Form Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
      <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Corejava